"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetStatus = void 0;
var ResetStatus;
(function (ResetStatus) {
    ResetStatus[ResetStatus["STARTED"] = 0] = "STARTED";
    ResetStatus[ResetStatus["FINISHED"] = 1] = "FINISHED";
})(ResetStatus = exports.ResetStatus || (exports.ResetStatus = {}));
